import { render, staticRenderFns } from "./quesInstru4.vue?vue&type=template&id=ff543026"
import script from "./quesInstru4.vue?vue&type=script&lang=js"
export * from "./quesInstru4.vue?vue&type=script&lang=js"
import style0 from "./quesInstru4.vue?vue&type=style&index=0&id=ff543026&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports